<div (click)="openDialog()" class="trigger">
  <ng-content></ng-content>
</div>

<ng-template #dialogContent>
  <form>
    <h3 mat-dialog-title>{{ title() }}</h3>

    <mat-dialog-content>
      <ui-form-text [data]="nameFieldItem()" [formControl]="nameFormControl"></ui-form-text>
    </mat-dialog-content>

    <mat-dialog-actions>
      @for (item of submitItems(); track item) {
        <ui-button
          [type]="item.name === 'submit' ? 'submit' : 'button'"
          (clicked)="onAction(item,$event)"
          [buttonStyle]="item.theme ?? 'text'"
          [disabled]="(nameFormControl.invalid && item.name === 'submit')">
          {{ item.label }}
        </ui-button>
      }
    </mat-dialog-actions>
  </form>
</ng-template>
